// extracted by mini-css-extract-plugin
module.exports = {"intro":"ProductList_intro__3n2Ub","intro_grid":"ProductList_intro_grid__v5rbt","category_list_container":"ProductList_category_list_container__2dMk6"};